// extracted by mini-css-extract-plugin
export default {"wrapper":"WithdrawBonusConfirmation_wrapper--sVb","text":"WithdrawBonusConfirmation_text--Uhu","buttonConfirm":"WithdrawBonusConfirmation_buttonConfirm--jUQ"};